export default __webpack_public_path__ + "static/media/Emerald@1x.800a7740.png";